import { useState, useEffect } from "react";
import PrimaryNav from "./PrimaryNav";
import MobileNav from "./MobileNav";

export default function NavBarComponent({ shouldShowPremiumBanner, theme }) {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < 1024);

  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 1024);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);

  return isMobile
    ? <MobileNav shouldShowPremiumBanner={shouldShowPremiumBanner} theme={theme} />
    : <PrimaryNav shouldShowPremiumBanner={shouldShowPremiumBanner} theme={theme} />;
}
